export default {
  // 標題文字
  title: {
    w1: "歡迎註冊融資界",
    w2: "歡迎登錄融資界",
    w3: "找回密碼",
    w4: "最新借款列表",
    w5: "域名質押行業領先，投資回報高效穩健",
    w6: "最新公告",
    w7: "行業資訊",
    w8: "手機驗證",
    w9: "郵箱驗證",
    w10: "關於我們",
    w11: "幫助中心",
    w12: "投資計算器",
    w13: "借款計算器",
    w14: "官方客服QQ",
    w15: "官方聯系電話",
    w16: "閱讀協議",
    w17: "我們的優勢",
    w18: "安全保障",
    w19: "屏蔽名單",
    w20: "重置登錄密碼",
    w21: "實名認證",
    w22: "重置交易密碼",
    w23: "設置交易密碼",
    w24: "修改綁定手機",
    w25: "手機綁定",
    w26: "修改綁定郵箱",
    w27: "郵箱綁定",
    w28: "修改銀行卡",
    w29: "添加銀行卡",
    w30: "添加屏蔽用戶名單",
    w31: "修改聯系地址",
    w32: "設置聯系地址",
    w33: "投資列表",
    w34: "質押域名",
    w35: "還款信用",
    w36: "平臺認證信息",
    w37: "質押域名類型",
    w38: "平臺公告",
    w39: "公告詳情",
    w40: "新聞資訊",
    w41: "新聞詳情",
    w42: "通知設置",
    w43: "玉米粒記錄",
    w44: "玉米粒兌換",
    w45: "填寫借款信息",
    w46: "確認借款信息",
    w47: "投資",
    w48: "借款",
    w49: "域名質押管理",
    w50: "信用周轉記錄",
    w51: "申請解除質押域名",
    w52: "修改註冊商",
    w53: "綁定註冊商",
    w54: "申請質押",
    w55: "凍結詳情",
    w56: "完善信息",
    w57: "撤銷投資",
    w58: "撤銷借款",
    w59: "本期還款",
    w60: "提前還款",
    w61: "幫助詳情",
    w62: "邀好友領獎勵上不封頂",
    w63: "我的獎金:",
    w64: "我的獎金 > 管理費賬戶",
    w65: "下載協議",
    w66: "請輸入手機驗證碼",
    w67: '優惠券',
    w68: '管理費減免券',
    w69: '有效期',
    w70: '不使用減免券',
    w71: '優惠券減免'
  },
  // 導航、鏈接 性質的文字
  nav: {
    w1: "我要投資",
    w2: "我要借款",
    w3: "查看更多",
    w4: "投資流程",
    w5: "借款流程",
    w6: "立即開啟",
    w7: "立即前往",
    w8: "資產中心",
    w9: "充值",
    w999: "去充值",
    w10: "提現",
    w11: "信用周轉",
    w12: "資金記錄",
    w13: "域名管理",
    w14: "批量質押域名",
    w15: "批量解除質押",
    w16: "註冊商管理",
    w17: "批量解除域名",
    w18: "批量質押域名",
    w19: "申請授信",
    w20: "賬號設置",
    w21: "提現銀行管理",
    w22: "我的訂單",
    w23: "投資訂單",
    w24: "借款訂單",
    w25: "自動投標",
    w26: "創建投標",
    w27: "回款續投配置",
    w28: "首頁",
    w29: "上頁",
    w30: "下頁",
    w31: "末頁",
    w32: "網站公告",
    w33: "新聞資訊",
    w34: "網站聲明",
    w35: "企業簡介",
    w36: "常見問題",
    w37: "我是借款人",
    w38: "我是投資人",
    w39: "通知",
    w40: "我的訂單",
    w41: "資產中心",
    w42: "賬戶設置",
    w43: "域名管理",
    w44: "自動投標",
    w45: "我的卡券",
    w46: "安全退出",
    w47: "兌換卡券",
    w48: "登錄",
    w49: "註冊",
    w50: "借款人信息",
    w51: "投資記錄",
    w52: "還款記錄",
    w53: "有效配置",
    w54: "失效配置",
    w55: "手動創建投標",
    w56: "銀行卡管理",
    w57: "去借款",
    w58: "忘記交易密碼",
    w59: "郵箱驗證",
    w60: "手機驗證",
    w61: "手機註冊",
    w62: "郵箱註冊",
    w63: "密碼登錄",
    w64: "動態登錄",
    w65: "忘記密碼",
    w66: "點擊註冊",
    w67: "批量解除",
    w68: "批量刪除",
    w69: "批量質押",
    w70: "快速還款",
    w71: "查看屏蔽名單",
    w72: "馬上投資",
    w73: "等待還款",
    w74: "轉移至管理費賬戶",
    w75: "選擇訂單數",
    w76: "還款期數",
    w77: "本息總額(元)",
    w78: "資金賬戶余額(元)",
    w79: "管理費總額(元)",
    w80: "管理費賬戶余額(元)",
    w81: "還需充值",
    w82: "還款計數器",
    w83: "壹鍵還款",
    w84: "借款描述",
    w85: "查看更多"
  },
  // label文字，表單label，描述性label，表頭文字
  label: {
    w1: "投資金額",
    w2: "借款金額",
    w3: "年利率",
    w4: "投資周期",
    w5: "元",
    w6: "應付利息",
    w7: "每期利息",
    w8: "應繳管理費",
    w9: "每期管理費",
    w10: "借款標",
    w11: "精品域名",
    w12: "100起投",
    w13: "期限",
    w14: "個月",
    w15: "天",
    w16: "金額/姓名/標號",
    w17: "周期",
    w18: "投標進度",
    w19: "操作",
    w20: "登錄密碼",
    w21: "交易密碼",
    w22: "郵箱綁定",
    w23: "手機綁定",
    w24: "實名認證",
    w25: "銀行卡管理",
    w26: "聯系地址",
    w27: "開戶行",
    w28: "銀行卡號",
    w29: "綁定日期",
    w30: "選擇國家/地區",
    w31: "身份信息",
    w32: "現住址",
    w33: "新交易密碼",
    w34: "重復密碼",
    w35: "手機驗證碼",
    w36: "郵箱驗證碼",
    w37: "原手機驗證碼",
    w38: "新手機號碼",
    w39: "新手機驗證碼",
    w40: "手機號碼",
    w41: "新密碼",
    w42: "原郵箱驗證碼",
    w43: "新郵箱地址",
    w44: "新郵箱驗證碼",
    w45: "郵箱地址",
    w46: "開戶姓名",
    w47: "選擇銀行",
    w48: "選擇地區",
    w49: "開戶支行",
    w50: "屏蔽用戶",
    w51: "編號",
    w511: "還款期數",
    w52: "利息",
    w53: "狀態",
    w54: "期數",
    w55: "管理費",
    w56: "本期本息",
    w57: "還款日期",
    w58: "應還款時間",
    w59: "本期還款",
    w60: "逾期罰金",
    w61: "還款狀態",
    w62: "實際還款時間",
    w63: '到期收益',
    w64: "已收本息",
    w65: "本金還款",
    w66: "逾期罰息",
    w67: "平臺獎勵",
    w68: "投資狀態",
    w69: "賬戶余額",
    w70: "管理費余額",
    w71: "修改年利率",
    w72: "增加",
    w73: "截止日期",
    w74: "投資進度",
    w75: "總利息",
    w76: "總管理費",
    w77: "分{%}期",
    w78: "每期",
    w79: "最後壹期本金還款",
    w80: "借款周期",
    w81: "還款方式",
    w82: "借款描述",
    w83: "借款類型",
    w84: "標剩余金額",
    w85: "預計利息",
    w86: "滿標用時",
    w87: "滿標時間",
    w88: "投資人數",
    w89: "發標時間",
    w90: "截止時間",
    w91: "下期還款時間",
    w92: "本期管理費",
    w93: "還款結束時間",
    w94: "借款本息",
    w95: "已付管理費",
    w96: "域名",
    w97: "品類",
    w98: "授信總額",
    w99: "已用授信",
    w100: "本標占比",
    w101: "投資人",
    w102: "投資時間",
    w103: "優惠券",
    w104: "近半年",
    w105: "近壹年",
    w106: "總計",
    w107: "逾期",
    w108: "提前",
    w109: "正常",
    w110: "違約",
    w111: "姓名",
    w112: "共發布貸款數",
    w113: "近半年有無逾期",
    w114: "性別",
    w115: "年齡",
    w116: "註冊日期",
    w117: "手機認證",
    w118: "郵箱認證",
    w119: "授信總額",
    w120: "授信占比",
    w121: "域名個數",
    w122: "發件人",
    w123: "時間",
    w124: "通知",
    w125: "公告",
    w126: "線下通知方式",
    w127: "有效期",
    w128: "玉米粒",
    w129: "類型",
    w130: "余額",
    w131: "受理時間",
    w132: "適用於",
    w133: "使用說明",
    w134: "有效時間",
    w135: "溫馨提示",
    w136: "選填",
    w137: "管理費率",
    w138: "到期還款金額",
    w139: "私標對象",
    w140: "可用額度",
    w141: "最多可借",
    w142: "優惠減免",
    w143: "配置狀態",
    w144: "保留金額",
    w145: "最低利率",
    w146: "域名類型",
    w147: "可用金額",
    w148: "已投資金額",
    w149: "投標總額",
    w150: "域名品類",
    w151: "失效時間",
    w152: "創建時間",
    w153: "標號",
    w154: "投資日期",
    w155: "投資總額",
    w156: "提現賬戶",
    w157: "提現金額",
    w158: "可提現",
    w159: "賬戶",
    w160: "註冊商",
    w161: "註冊ID",
    w162: "驗證信息",
    w163: "日期",
    w164: "收入",
    w165: "支出",
    w166: "賬戶總額",
    w167: "說明",
    w168: "可用余額",
    w169: "凍結金額",
    w170: "私標",
    w171: "周轉標",
    w172: "管理費賬戶可用余額",
    w173: "本月需還款",
    w174: "管理費凍結資金",
    w175: "最近壹個月內預計收益",
    w176: "已投資",
    w177: "待收款",
    w178: "累計收益",
    w179: "最近壹個月內還需還款",
    w180: "已借款",
    w181: "待還款",
    w182: "違約欠款",
    w183: "個",
    w184: "可用授信",
    w185: "已授信域名",
    w186: "已質押域名",
    w187: "授信時間",
    w188: "域名狀態",
    w189: "借款狀態",
    w190: "信用額度",
    w191: "大寫額度",
    w192: "申請時間",
    w193: "周轉額度",
    w194: "關聯項目",
    w195: "賬號",
    w196: "我的域名",
    w197: "授信金額",
    w198: "凍結日期",
    w199: "賬戶名",
    w200: "密碼",
    w201: "驗證碼",
    w202: "新登錄密碼",
    w203: "月",
    w204: "利率",
    w205: "金額",
    w206: "投資返現",
    w207: "邀請碼",
    w208: "邀請人數",
    w209: "累計獎勵",
    w210: "邀請鏈接",
    w211: "復制鏈接",
    w212: "邀請記錄",
    w213: "獎勵記錄",
    w214: "序號",
    w215: "好友",
    w216: "註冊時間",
    w217: "獎勵時間",
    w218: "獎勵類型",
    w219: "獎勵金額(元)",
    w220: "轉移金額",
    w221: "滑動驗證",
    w222: "已開啟",
    w223: "已關閉",
    w224: "開啟",
    w225: "關閉",
    w226: '應收利息',
    w227: '應付管理費',
    w228: '每期管理費',
    w229: '預計收益',
    w230: '每期收益',
    w231: '預計收益',
    w232: '收益',
    w233: `<div class='daoqi'>到期收益<i class="icon-active1 pre1" onclick="toCheck()"/></div>`,
    w234: '到期利息',
    w235: '手機號(必須是綁定該身份證的手機號碼！)'

  },
  // 輸入框placeholder
  pl: {
    p1: "手機/郵箱",
    p2: "請輸入郵箱驗證碼",
    p3: "8-16位數字、字母或字符組合",
    p4: "請再次輸入密碼",
    p5: "手機/郵箱/ID",
    p6: "請輸入密碼",
    p7: "請輸入手機號",
    p8: "請輸入驗證碼",
    p9: "請輸入郵箱地址",
    p10: "請輸入要授信的域名，每行壹個，壹次最多500個",
    p11: "請輸入交易密碼",
    p12: "開始時間",
    p13: "請輸入",
    p14: "手機",
    p15: "郵箱",
    p16: "驗證碼",
    p17: "請輸入額度",
    p18: "請輸入域名",
    p19: "結束時間",
    p20: "請輸入100的整數倍，且不小於1000",
    p21: "請輸入保留金額",
    p22: "請輸入需要搜索的關鍵字",
    p23: "請輸入100元的整數倍",
    p24: "請輸入聯系地址",
    p25: "請輸入要屏蔽的用戶姓名",
    p26: "如：科技園支行",
    p27: "請輸入銀行卡號",
    p28: "請輸入手機驗證碼",
    p29: "請再次輸入新密碼",
    p30: "請輸入短信驗證碼",
    p31: "請輸入郵箱驗證碼",
    p32: "不超過{%}%",
    p33: "請聯系客服獲取邀請碼",
    p34: "請輸入訂單號",
    p35: '請輸入域名',
    p36: '訂單號',
    p37: '域名',
    p38: '搜索'
  },
  // 提示信息，彈出提示信息，輸入框錯誤提示信息
  msg: {
    m1: "未找到相關數據",
    m2: "請上傳身份證頭像頁",
    m3: "只允許上傳.jpg和.png的文件",
    m4: "香港居民身份證頭像頁",
    m5: "護照信息頁照",
    m6: "請再次輸入密碼",
    m7: "兩次輸入密碼不壹致",
    m8: "還沒有賬號？",
    m9: "已有賬號？",
    m10: "請先將您的域名PUSH到以下指定賬戶，PUSH完成後再提交質押申請。",
    m11: "已存在",
    m12: "提交失敗",
    m13: "個成功",
    m14: "個失敗",
    m15: "域名解除質押後將push到以下賬戶，請確認。",
    m16: "1、請上傳清晰圖片，若添加水印、遮擋物可能無法識別。",
    m17: "3、僅支持.jpg .png的圖片格式，圖片大小不得超過15M。",
    m18: "身份證識別失敗",
    m19: "您所提交的身份證圖片無法識別或已被使用，請重新上傳清晰的圖片，如有疑問，請聯系客服人員。",
    m20: "提交失敗！",
    m21: "提交成功！",
    m22: "加入屏蔽名單的用戶自動投標將被屏蔽",
    m23: "是否確定刪除此銀行卡？",
    m24: "刪除成功",
    m25: "現住址不能為空",
    m26: "手機號不能為空",
    m27: "手機號碼格式不正確",
    m28: "手機號碼不正確",
    m29: "取消屏蔽成功",
    m30: "認證成功",
    m31: "兩次密碼輸入不壹致",
    m32: "密碼不能為空",
    m33: "重置成功",
    m34: "設置成功",
    m35: "手機綁定修改成功",
    m36: "綁定成功",
    m37: "登錄密碼已重置，請重新登錄！",
    m38: "綁定郵箱修改成功",
    m39: "開戶支行不能為空",
    m40: "修改成功",
    m41: "添加成功",
    m42: "屏蔽用戶不能為空",
    m43: "添加屏蔽成功",
    m44: "聯系地址不能為空",
    m45: "設置成功",
    m46: "沒有未讀通知",
    m47: "請先選擇要刪除的通知",
    m48: "當前狀態不可申請",
    m49: "請先選擇質押域名",
    m50: "確認撤銷自動投標",
    m51: "金額不能為空",
    m52: "金額格式不正確",
    m53: "提交成功，請耐心等待審核",
    m54: "請先設置交易密碼",
    m55: "是否確定刪除該註冊商信息？",
    m56: "刪除域名",
    m57: "請先綁定",
    m58: "註冊商賬號",
    m59: "請先選擇域名",
    m60: "刪除域名選中的域名",
    m61: "請輸入正確的金額",
    m62: "請先驗證交易密碼和驗證碼",
    m63: "請先閱讀並同意《域名價值估算協議》",
    m64: "請先輸入域名",
    m65: "壹次提交域名不能超過500個",
    m66: "請先實名認證",
    m67: "賬號不能為空",
    m68: "驗證信息不能為空",
    m69: "該手機已經被使用",
    m70: "郵箱不能為空",
    m71: "郵箱格式錯誤",
    m72: "該郵箱已經被使用",
    m73: "註冊成功！",
    m74: "自動投標可滿足{%}%的借款",
    m75: "當前存在質押借款的域名自動拆分單獨借款標",
    m76: "您還沒有質押域名獲取授信額度，不能申請借款。",
    m77: "數據請求失敗",
    m78: "退出登錄成功",
    m79: "請上傳香港居民身份證頭像頁",
    m80: "請上傳護照信息頁照",
    m81: "登錄狀態已失效，請重新登錄",
    m82: "驗證碼不能為空",
    m83: "密碼長度必須是8-16位",
    m84: "密碼不正確",
    m85: "銀行卡號不能為空",
    m86: "不能為空",
    m87: "共{%}個",
    m88: "發布失敗",
    m89: "發布成功",
    m90: "還差{%}玉米粒",
    m91: "兌換成功",
    m92: "已發放至 - 我的卡券",
    m93: "質押域名僅借貸雙方可見",
    m94: "停止計息",
    m95: "年利率不能小於原年利率",
    m96: "確認撤銷投資",
    m97: "確認撤銷借款標",
    m98: "余額不足",
    m99: "信用周轉",
    m100: "您當前尚無可質押域名",
    m101: "您當前尚無可解除域名",
    m102: "您當前尚無此投資訂單",
    m103: "您當前尚無此借款訂單",
    m104: "您當前暫無信用周轉記錄",
    m105: "您當前尚無授信域名",
    m106: "您當前尚無可解除域名",
    m107: "您當前尚無可刪除域名",
    m108: "您當前尚無可質押域名",
    m109: "您當前尚無凍結資金",
    m110: "您當前未綁定註冊商",
    m111: "您當前尚未創建自動投標",
    m112: "您暫無可用卡券",
    m113: "您暫無已用卡券",
    m114: "您暫無失效卡券",
    m115: "暫無可兌換卡券，敬請期待!",
    m116: "您當前尚無獲得玉米粒記錄",
    m117: "當前尚無新聞資訊",
    m118: "當前尚無公告",
    m119: "您當前暫無消息記錄",
    m120: "當前暫無借款標",
    m121: "您當前尚未添加銀行卡",
    m122: "您暫未添加屏蔽名單",
    m123: "3、請提交您本人的證件照，壹經認證不可修改。",
    m124: "您當前尚無借款，無需開通管理費賬戶",
    m125: "優惠券匯率高於或等於實際匯率，不需使用優惠券",
    m126: "本平臺管理費率采取階梯式收取規則",
    m127: "復制成功",
    m128: "復制失敗",
    m129: "尚無邀請記錄",
    m130: "尚無獎勵記錄",
    m131: "您當前尚無資金記錄",
    m132: "最多可轉",
    m133: "密碼格式不正確（若原密碼格式不正確，請設置新交易密碼）",
    m134: "開啟成功",
    m135: "關閉成功",
    m136: '邀請碼不能為空',
    m137: '邀請碼是由數字和字母組成的6位數'
  },
  // 按鈕文字
  btn: {
    b1: "我再想想",
    b2: "確認刪除",
    b3: "重新上傳",
    b4: "下壹步",
    b5: "確認",
    b6: "重置",
    b7: "篩選",
    b8: "不同意",
    b9: "同意",
    b10: "立即登錄",
    b11: "立即註冊",
    b12: "確認質押",
    b13: "確認解除",
    b14: "繼續申請授信",
    b15: "返回域名管理",
    b16: "確認申請",
    b17: "退出質押",
    b18: "退出移除",
    b19: "確認移除",
    b20: "申請額度",
    b21: "查詢",
    b22: "批量操作",
    b23: "申請授信",
    b24: "退出批量操作",
    b25: "刪除",
    b26: "修改",
    b27: "綁定註冊商",
    b28: "提現",
    b29: "我再想想",
    b30: "確認撤銷",
    b31: "創建投標",
    b32: "發布借款",
    b33: "重新發布",
    b34: "查看卡券",
    b35: "玉米粒兌換",
    b36: "更新設置",
    b37: "全部標為已讀",
    b38: "馬上投資",
    b39: "撤銷",
    b40: "加息",
    b41: "提前還款",
    b42: "本期還款",
    b43: "確認還款",
    b44: "充值",
    b45: "確認屏蔽",
    b46: "提交",
    b47: "保存",
    b48: "重新上傳",
    b49: "提交審核",
    b50: "正在驗證",
    b51: "添加屏蔽名單",
    b52: "取消屏蔽",
    b53: "去重置",
    b54: "去設置",
    b55: "去修改",
    b56: "去綁定",
    b57: "去認證",
    b58: "重新認證",
    b59: "去管理",
    b60: "添加銀行卡",
    b61: "已兌完",
    b62: "立即兌換",
    b63: "保存設置",
    b64: "創建投標",
    b65: "凍結詳情",
    b66: "等待還款",
    b67: "發送驗證碼",
    b68: "{%}s後可重發",
    b69: "收起",
    b70: "詳情",
    b71: "解除",
    b72: "質押",
    b73: "全部提取",
    b74: "馬上質押",
    b75: "進行中",
    b76: "已還款",
    b77: "已取消",
    b78: "全部",
    b79: "還款",
    b80: "復制鏈接",
    b81: "生成海報",
    b82: "活動詳情",
    b83: "立即邀請",
    b84: "下載到桌面",
    b85: "全部轉移",
    b86: "壹鍵還款",
    b87: '我知道了'

  },
  // 選項文字，Select組件內選項
  option: {
    w1: "全選",
    w2: "請選擇利率",
    w3: "10%以下",
    w4: "10%～20%",
    w5: "20%以上",
    w6: "請選擇周期",
    w7: "1個月以下",
    w8: "1個月～3個月",
    w9: "4個月～6個月",
    w10: "7個月～9個月",
    w11: "10個月～12個月",
    w12: "請選擇金額",
    w13: "1萬元以內",
    w14: "1萬元～10萬元",
    w15: "10萬元以上",
    w16: "去認證",
    w17: "已認證",
    w18: "當前無待還款訂單",
    w19: "信用周轉申請審核中",
    w20: "信用周轉申請已受理",
    w21: "當前已有信用周轉借款標",
    w22: "域名狀態",
    w23: "授信審核中",
    w24: "授信失敗",
    w25: "已授信",
    w26: "質押審核中",
    w27: "已質押",
    w28: "質押解除",
    w29: "未質押",
    w30: "借款狀態",
    w31: "已借款",
    w32: "未借款",
    w33: "全部",
    w34: "資金賬戶",
    w35: "管理費賬戶",
    w36: "無",
    w37: "1天",
    w38: "2天",
    w39: "已設置",
    w40: "未設置",
    w41: "未綁定",
    w42: "未認證",
    w43: "審核中",
    w44: "未通過",
    w45: "已綁定",
    w46: "張",
    w47: "屏蔽",
    w48: "郵箱",
    w49: "短信",
    w50: "手動設置",
    w51: "回款續投",
    w52: "已開啟",
    w53: "已關閉",
    w54: "{%}%管理費優惠券",
    w55: "先息後本（每月付息，到期還本）",
    w56: "未使用",
    w57: "已使用",
    w58: "已失效",
    w59: "{%}%投資加息券",
    w60: "{%}元投資紅包",
    w61: "借款",
    w62: "投資",
    w63: "有",
    w64: "信用周轉借款",
    w65: "域名質押借款",
    w66: "{%}人",
    w67: "取消全選",
    w68: "暫不使用優惠券",
    w69: "好友借款",
    w70: "好友投資",
    w71: "獎勵金賬戶",
    w72: "不使用優惠券"
  },
  // 其他，無法歸類或歸類不明確的文字
  other: {
    w1: "投資人",
    w2: "操作便捷 收益穩健",
    w3: "借款人",
    w4: "域名質押 專業高效",
    w5: "嚴格風控",
    w6: "甄選優質域名 嚴格把控風險",
    w7: "安全保障",
    w8: "多重信息技術保障安全",
    w9: "更優質的投資體驗，就在融資界",
    w10: "融資界自上線已安全運營超過3年，贏得了超過20000用戶的信賴，我們不斷超越自己，超越 行業，為用戶帶來更優質的投資體驗",
    w11: "累計會員數(人)",
    w12: "累計成交總額(億元)",
    w13: "滿標平均用時(分鐘)",
    w14: "融資界專註深耕域名質押投融資領域，以先進的技術和資深的行業資源，把域名作為質押物，為域名持有人提供高效專業的融資服務，為投資用戶提供高效穩健的投資渠道，在投融資用戶間搭建壹道專業可靠的橋梁。",
    w15: "註冊認證",
    w16: "成為會員，身份認證",
    w17: "賬戶充值",
    w18: "充值匯款，快速到賬",
    w19: "選擇投資",
    w20: "選擇項目，確認投資",
    w21: "獲取收益",
    w22: "每月收息，到期回本",
    w23: "申請授信",
    w24: "申請授信，質押域名",
    w25: "發標借款",
    w26: "發布借款，等待投資",
    w27: "資金提現",
    w28: "滿標提現，資金到賬",
    w29: "沒有時間投標？",
    w30: "試試RONGZIJIE自動投標",
    w31: "祢的域名值多少錢？",
    w32: "快來了解域名最新行情價格",
    w33: "周壹至周五 09:00-18:00",
    w34: "溫馨提示：市場有風險，出借需謹慎",
    w35: "2016-2019 WRZ Inc. 粵ICP備16001344號",
    w36: "已有{%}筆投資",
    w37: `<p class="p1">尊敬的用戶：</p>
    <p class="p1"> 融資界由HONGKONG PROFIT POWER LIMITED建立並運營，在您使用融資界網站之前，融資界聲明如下：</p>
    <p class="p3">（1）融資界僅為註冊用戶提供域名服務，不向社會公眾即社會不特定對象提供服務;</p>
    <p class="p3">（2）融資界不承諾在任何期限內以貨幣、實物、股權等方式還本付息或者給付回報;</p>
    <p class="p3">（3）融資界非融資主體，不承擔任何保證、擔保、承兌、剛兌責任，也沒有任何償還投資款的義務;</p>
    <p class="p3"><span>（4）</span><span>融資界的域名信息均系註冊用戶發布，對註冊用戶發布的融資信息，您應該準確辨別，識別其中的風險，尤其應該註意會導 致投資款或域名受到損失的風險，包括但不限於政策風險、域名行情風險、信用風險等風險; </span> </p>
    <p class="p3">（5）若發生違約，域名壹律通過拍賣、議價、壹口價、打包價等方式進行處置。</p>
    <p class="p4">特此聲明。</p>
    <p class="p2">HONGKONG PROFIT POWER LIMITED </p>`,
    w38: "您好！請問您需要什麽幫助？",
    w39: `<p class="color-g2">融資界，是香港利勝科技有限公司旗下網站，成立於2019年，是專業的全球域名資產服務平臺。</p>
    <p class="color-g2">基於對域名行業和金融行業的深刻理解，為用戶提供全球域名融資的相關信息，並與國內外多家域名註冊商合作，幫助投資人或借款人暫時托管或鎖定域名。</p>
    <p class="color-g2">平臺基於自身的優勢並結合互聯網技術為用戶搭建壹個穩定，便捷，高效，誠信的信息中介服務平臺，公司的服務理念是：公平，旨在服務於全球的用戶。</p>`,
    w40: "投資收益快",
    w41: "（最短7天回款）",
    w42: "投資零費用",
    w43: "（不收取任何費用）",
    w44: "投資安全",
    w45: "借款便捷",
    w46: "（全部流程線上完成）",
    w47: "借款高效",
    w48: "（最快2小時滿標放款）",
    w49: "借款服務優質",
    w50: "（客服壹對壹服務）",
    w51: "投資安全",
    w52: "（專業風控團隊對質押物進行審核）",
    w53: "資金安全",
    w54: "（國際領先的系統加密及保護技術，內部嚴格的資金管理流程）",
    w55: "數據安全",
    w56: "（采取各種合適的物理、電子和管理方面的措施來保護數據，以實現對數據安全的承諾）",
    w57: "隱私保護",
    w58: "（嚴格遵守保密責任）",
    w59: "《風險告知書》",
    w60: "《域名投資協議》",
    w61: "《域名信用周轉協議》",
    w62: "市場有風險，投資需謹慎",
    w63: "已閱讀並同意",
    w64: "逾期{%}天",
    w65: "或",
    w66: "可查看詳細信息",
    w67: "投標後是否可以撤銷投資？",
    w68: "所有投資的借款項目未滿標的情況下，投資人可撤銷投資，若所投資的借款項目已滿標，則無法撤銷投資。若借款人在借款項目未滿標時撤銷項目或者項目在規定時間內未滿標自動流標，則所投資金自動返回投資人賬戶。",
    w69: "借款利息什麽時候計算？",
    w70: "借款利息是從借款項目滿標的當天開始計算。",
    w71: "如何收取還款？",
    w72: "借款人在規定的還款時間內將規定的還款金額充值到賬戶，融資界平臺將根據各個投資人的投資比例，自動將投標本息打入投資人賬戶，並且融資界平臺系統會發送郵件、短信、賬內信通知投資人，投資人可按個人需求選擇提現，或繼續投資。",
    w73: "借款人不還錢怎麽辦？",
    w74: "若借款人未在規定的時間償還所欠款項，融資界平臺將加收所欠款項的0.06%/日作為罰金；同時融資界有權通知域名托管人處置域名，包括不限於拍賣、壹口價、直接出售等形式，所得價款清償所欠款項後，如有余款，融資界將其退還給借款人；如不足，投資人自行承擔損失。融資界平臺強烈呼籲借款用戶盡量避免逾期還款，壹旦發生逾期請盡快還清款項，平臺有權根據具體情況將用戶列入不良信用客戶名單。",
    w75: "能提前收回借款嗎？",
    w76: "投資資金壹旦成功投資，不可提前收回投資的款項，除非借款人自願提前還清欠款。",
    w77: "共質押域名{%}個，授信總額{%}元",
    w78: '共<span>{%}</span>封，其中未讀通知<span class="color-b s1">{%}</span>封',
    w79: "已勾選未讀通知 {%} 封",
    w80: "管理員",
    w81: "融資界",
    w82: "我的玉米粒: {%}顆",
    w83: "投資金額{%}元以上",
    w84: "剩余{%}張",
    w85: "自兌換日{%}天內",
    w86: "融資界信用周轉",
    w87: "幫您輕松解決資金難題",
    w88: "信用額度融到的資金僅限於還款，不允許提現、投標等其它用途",
    w89: "申請額度：用戶提出申請後由平臺根據用戶個人情況審核並給予壹定的額度，每天最多只能申請壹次信用周轉額度，最低申請額度為1000元",
    w90: "信用額度當天申請當天使用，過期作廢，有未償還的信用周轉額度時，不能再次申請額度",
    w91: "使用信用周轉額度發布的融資標期限為1-2天；管理費為周轉額度的0.6‰/天",
    w92: "截止時間前未滿標，則自動取消該筆借款。",
    w93: `<p>1、發布的借款項目滿標後則無法撤銷，請務必認真填寫各項信息；</p>
    <p>2、借款人主動提前還款的，應當按借款期滿時應當支付的本金、利息、管理費總額還款，具體以平臺計算金額為準；</p>
    <p>3、域名可用額度小於授信額度時，發標後系統將會自動分標；</p>`,
    w94: "輸入指定的用戶ID作為承接對象，默認為0則不是私標。",
    w95: "截止時間前未滿標，則自動取消該筆借款。",
    w96: "{%}個域名",
    w97: "1、如借款人出現違約情況，平臺將按照合同處置域名清償債務，如處置域名所得實際款項不足以償還債務，投資人需自行承擔該風險與損失。融資界不承擔擔保、兌付責任。",
    w98: "2、特別提醒：回款資金有提現需求的用戶請謹慎使用此功能，隨時註意開啟與關閉，因用戶設置不當造成的損失由用戶自行承擔。",
    w99: "3、已開啟自動投標屏蔽，加入屏蔽名單的用戶借款標將不被投標，",
    w100: `<p class="tit">
      1.帳戶提現到賬規則為：
      <br>
      <span>資金賬戶：工作日9:00-18:00；周末及節假日10:00-16:30。</span>
      <br>
      <span>獎勵金及管理費賬戶：工作日11:00與17:00統壹處理提現；周末及節假日不處理提現。 </span>
      <br>
    </p>
    <p>2.為了您的資金安全，請確保提現銀行戶名與您的真實姓名壹致。</p>
    <p>3.提現不收取手續費。</p>
    <p>4.平臺禁止洗錢、信用卡套現、虛假交易等行為，壹經發現並確認，將終止該賬戶的使用。</p>`,
    w101: `投資、還本息請充值到<span class='red'>資金賬戶</span>，支付管理費請充值到<span class="red">管理費賬戶</span>，兩個賬戶資金不能互轉，資金賬戶的余額無法用於支付管理費。`,
    w102: "請保證您所用於投資的資金來源合法，且是該資金的合法支配 權人，嚴禁洗錢、信用卡套現等不良行為，壹經發現將嚴厲處 罰，包括但不限於：限制提現、凍結賬戶。",
    w103: "請轉賬到以下指定的銀行卡賬號，並聯系客服進行充值。",
    w104: "收款人",
    w105: "林诗意",
    w1051: "魏安阳",
    w106: "中国银行深圳南山支行",
    w107: "開戶行",
    w108: "賬&nbsp;&nbsp;&nbsp;號",
    w109: "深圳互联利胜科技有限公司",
    w110: "中国光大银行学府路支行",
    w111: "什麽是玉米粒？",
    w112: "每成功借款或投資100元，記壹玉米粒，可用於兌換活動優惠券。",
    w113: "《域名價值估算協議》",
    w114: "請提交您要申請授信的域名，平臺將在1—2個工作日內審核授信。",
    w115: "每個域名占壹行，如需提交多個域名，請分行輸入，最多可輸入500行；",
    w116: "平臺只接受有固定價值區間的域名（例如rzj.com）某些域名雖然有很高的價值，但難以評估，平臺不提倡質押。",
    w117: "《域名托管協議》",
    w118: "《用戶服務協議》",
    w119: "《隱私保護協議》",
    w120: "萬",
    w121: "月（待還本金+本次借款",
    w122: "待還本金+本次借款金額",
    w123: "時間周期：1-12個月",
    w124: "邀請好友投資，獎勵投資金額*月數*",
    w125: "邀請好友借款，獎勵借款金額*月數*",
    w126: "活動規則說明:",
    w127: "1.投資周期為7天和15天，則按7/30和15/30結算獎勵。",
    w128: "2.單筆獎金不足0.01CNY則忽略不計。",
    w129: "3.標的滿標生效後，獎勵壹次性發放。",
    w130: "4.活動時間：2019.07.10-2020.07.10。",
    w131: "5.活動最終解釋權歸融資界所有。",
    w132: "本金",
    w133: "利息",
    w134: "罰金",
    w135: "管理費",
    w136: '平安银行南头城支行',
    w137: '預計收益=利息-管理費',
    w138: '自2020年8月8日起生效的訂單，每月將收取投資金額0.1%作為管理費，詳情請',
    w139: '查看公告',
    w140: '感謝您壹直以來對融資界平臺的支持與厚愛！為了讓平臺更加健康的發展，給您壹個更加安全的投資環境，平臺風控團隊全新升級，增加了更加專業的風控人員，由此也相應增加了公司的管理成本，經過公司高層和風控團隊協商後，以對用戶權益造成最小影響的前提下，公司會議慎重決定對投資用戶適當收取最低金額的管理費，由此給您造成的影響敬請諒解。',
    w141: '管理費收費標準如下：',
    w142: '1.收費標準：投資金額*0.1%/月；',
    w143: '2.收費方式：從投資用戶收益中自動扣取相應管理費；',
    w144: '3.收費時間：自2020年8月8日起(該日期後投資的訂單將收取相應管理費）；',
    w145: '感謝您壹直以來對融資界的關註和支持！如果您有任何疑問請聯系平臺客服，我們將竭誠為您服務。',
    w147: '我已知悉',
    w148: '重要公告',
    w149: '尊敬的投資用戶：',
    w150: '您好!',
    w151: '所有訂單均可使用',
    w152: '用於支付管理費'
  }
};
